import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/HomeContent.tsx");
